/** Uzi, as a thing you can carry. The gun itself is `sim/weapons/guns/uzi.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const UZI_ITEM = {
  id: 'uzi',
  kind: 'weapon',
  label: 'Uzi',
  description: 'A stamped box with the magazine in the grip. Cheap, loud, and everywhere.',
  rarity: 'common',
  weightKg: 3.5,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'uzi',
} as const satisfies WeaponItem;
